import 'semantic-ui-css/components/modal.min.css';
import 'semantic-ui-css/components/dimmer.min.css';
import 'semantic-ui-css/components/checkbox.min.css';
import 'semantic-ui-css/components/transition.min.css';
import 'normalize.css/normalize.css';
import './global.css';
import './semantic-ui-overrides.css';
export default {
    break: {
        tinyAlt: '479px',
        tiny: '480px',
        small: '767px',
        medium: '1024px',
        mediumAlt: '1023px',
        largeHD: '1279px',
        large: '1439px',
        largeXHD: '1599px',
        largeFHD: '1919px',
    },
    height: {
        small: '767px',
        medium: '899px',
        large: '1079px',
    },
    color: {
        // Shade //
        black: '#000',
        base: '#1F2027',
        darkGrey: '#4C4D52',
        midGrey: '#777',
        grey: '#ADADAD',
        lightGrey: '#DDD',
        silver: '#EEE',
        nearWhite: '#F8F8F8',
        white: '#FFF',
        darkGreyHover: '#6A6D78',
        // General Color //
        yellow: '#FECF00',
        lightYellow: '#FEF9E7',
        yellowHover: '#FFDF52',
        blue: '#1F60EC',
        blueHover: '#5384EC',
        green: '#2FB457',
        red: '#D0021B',
        redHover: '#D93549',
        // Status
        success: '#2FB457',
        warning: '#FC8527',
        error: '#D0021B',
        sleep: '#191970',
        // Border / Section / Component use //
        borderSection: '#CCC',
        borderInput: '#DDD',
        // Role
        member: '#EA4B89',
        viewer: '#EE4B3E',
        admin: '#277BEB',
        owner: '#1F2027',
        contributor: '#4C4D52',
        creator: '#3E9296',
        manager: '#5A339F',
        publisher: '#587291',
        // Code Editor
        codeText: '#DDDCAA',
        codeStyle: '#9CDCFF',
        codeVariable: '#C586C0',
    },
    default: {
        borderRadius: 'border-radius: 4px',
        actionBorderRadius: 'border-radius: 4px',
        cardBorderRadius: 'border-radius: 6px',
        actionHeight: 'height: 45px',
        cardShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.1)',
        inputShadow: 'box-shadow: 0 1px 2px 0 rgba(0,0,0,.05)',
        actionHeightMobile: 'height: 38px',
        horizontalPadding: '10px',
        verticalPadding: '10px',
        horizontalMargin: '10px',
        verticalMargin: '10px',
    },
    sidebar: {
        minWidth: '70px',
        maxWidth: '240px',
    },
    sidebarRight: {
        minWidth: '260px',
        maxWidth: '320px',
        smallMaxWidth: '260px',
    },
    admin: {
        desktopHorizontalPadding: '20px',
        mobileHorizontalPadding: '12px',
        desktopVerticalPadding: '20px',
        mobileVerticalPadding: '12px',
        desktopVerticalMargin: '24px',
        mobileVerticalMargin: '16px',
        header: {
            desktopHeight: '70px',
            mobileHeight: '64px',
        },
        nav: {
            desktopHeight: '60px',
            mobileHeight: '50px',
        },
    },
    subheader: {
        styled: "\n    span,\n    .button {\n      text-transform: uppercase;\n      color: #ADADAD;\n      z-index: 1;\n      position: relative;\n      height: 40px;\n      font-size: 12px;\n      display: inline-flex;\n      align-items: center;\n      letter-spacing: 0.1em;\n      line-height: 1;\n      font-weight: 900;\n\n      i {\n        width: 8px;\n        margin-left: 5px;\n        height: 4px;\n        background-color: #ADADAD;\n      }\n    }\n    ",
    },
};
//# sourceMappingURL=theme.config.js.map